import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'lpad'
})
export class LPadPipe implements PipeTransform {
  transform(item : number, pad: number = 2, char = "0"): any {
    return String(item).padStart(pad, char);
  }
}